var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "icon-code-snippet codeblock-tabbed margin-bottom-xl",
      attrs: { id: "icon-code-snippet" },
    },
    [
      _vm.icon
        ? _c("div", [
            _c(
              "div",
              { staticClass: "tabs", attrs: { role: "tablist" } },
              _vm._l(_vm.syntaxes, function (syntax) {
                return _c(
                  "button",
                  {
                    key: syntax,
                    staticClass: "tab size-sm",
                    staticStyle: {
                      "--tab-color": "var(--fa-blue)",
                      "letter-spacing": "1px",
                      "text-wrap": "nowrap",
                    },
                    attrs: {
                      id: `tab-${_vm.sluggifySyntax(syntax)}`,
                      type: "button",
                      role: "tab",
                      "aria-controls": `code-snippet-${_vm.sluggifySyntax(
                        syntax
                      )}`,
                      "aria-selected":
                        _vm.showing == _vm.sluggifySyntax(syntax)
                          ? "true"
                          : "false",
                    },
                    on: {
                      click: function ($event) {
                        _vm.showSnippet(_vm.sluggifySyntax(syntax))
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(syntax) + "\n      ")]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          { staticClass: "code-snippet-content codeblock-container" },
          [
            _c("icon-code-snippet-html", {
              attrs: {
                "default-styles": _vm.defaultStyles,
                "has-custom-styling": _vm.hasCustomStyling,
                icon: _vm.icon,
                "is-duotone": _vm.isDuotone,
                showing: _vm.showing,
                styling: _vm.styling,
                "translated-style": _vm.translatedStyle,
                "major-version": _vm.activeMajorVersion,
              },
              on: { markCopied: _vm.markCopied },
            }),
            _vm._v(" "),
            _c("icon-code-snippet-web-awesome", {
              attrs: {
                "default-styles": _vm.defaultStyles,
                icon: _vm.icon,
                "is-duotone": _vm.isDuotone,
                showing: _vm.showing,
                styling: _vm.styling,
                "major-version": _vm.activeMajorVersion,
              },
            }),
            _vm._v(" "),
            _c("icon-code-snippet-react", {
              attrs: {
                "default-styles": _vm.defaultStyles,
                "has-custom-styling": _vm.hasCustomStyling,
                icon: _vm.icon,
                "is-custom-icon": _vm.isCustomIcon,
                showing: _vm.showing,
                styling: _vm.styling,
                "translated-style": _vm.translatedStyle,
                "major-version": _vm.activeMajorVersion,
              },
              on: {
                click: function ($event) {
                  return _vm.handleIntegrationClick("react")
                },
              },
            }),
            _vm._v(" "),
            _c("icon-code-snippet-vue", {
              attrs: {
                "default-styles": _vm.defaultStyles,
                "has-custom-styling": _vm.hasCustomStyling,
                icon: _vm.icon,
                "is-custom-icon": _vm.isCustomIcon,
                showing: _vm.showing,
                styling: _vm.styling,
                "translated-style": _vm.translatedStyle,
                "major-version": _vm.activeMajorVersion,
              },
              on: {
                click: function ($event) {
                  return _vm.handleIntegrationClick("vue")
                },
              },
            }),
            _vm._v(" "),
            _c("icon-code-snippet-svg", {
              attrs: {
                "active-version": _vm.activeVersion,
                "default-styles": _vm.defaultStyles,
                icon: _vm.icon,
                "is-custom-icon": _vm.isCustomIcon,
                "has-custom-styling": _vm.hasCustomStyling,
                "kit-version": _vm.kitVersion,
                showing: _vm.showing,
                styling: _vm.styling,
                "major-version": _vm.activeMajorVersion,
                viggo: _vm.viggo,
              },
              on: {
                copySvg: _vm.copySvg,
                "svg-format-change": (value) =>
                  _vm.$emit("svg-format-change", value),
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }